var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shipmentInfo)?_c('div',[_c('div',[_c('div',{staticClass:"shipment-modal-container",class:[_vm.open ? 'open' : 'closed']},[_vm._v("Successfully Created Shipment!")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }